import schoolListStore from '@modules/school/school-list-store';
import schoolViewStore from '@modules/school/school-view-store';
import schoolImporterStore from '@modules/school/school-importer-store';
import schoolFormStore from '@modules/school/school-form-store';
import schoolDestroyStore from '@modules/school/school-destroy-store';

export default {
    namespaced: true,

    modules: {
        destroy: schoolDestroyStore,
        form: schoolFormStore,
        list: schoolListStore,
        view: schoolViewStore,
        importer: schoolImporterStore,
    },
};